import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-70px);
  }
  to{
    opacity: 1;
    transform: translateX(0);
  }
`;

interface ContentProps {
  typeProps: 'leitura' | 'escrita';
}

export const Content = styled.div<ContentProps>`
  background: ${(props) => props.theme.colors.white};
  border-radius: 16px;
  max-height: ${(props) =>
    props.typeProps === 'escrita'
      ? 'calc(100vh - 323px)'
      : 'calc(100vh - 406px)'};

  overflow: auto;
  animation: ${appearFromLeft} 1s;
`;

export const HeaderMonth = styled.header`
  margin: 16px 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  h2 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: ${(props) => props.theme.colors.black};
    margin-right: 45px;
  }

  button {
    background: transparent;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      color: ${(props) => props.theme.colors.primary};
      width: 26px;
      height: 26px;

      transition: color 0.2s;

      &:hover {
        color: ${(props) => shade(0.2, props.theme.colors.primary)};
      }
    }

    & + button {
      margin-left: 30px !important;
    }
  }
`;

export const HeaderWeek = styled.div`
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  border-radius: 16px 16px 0 0;
  padding: 22px; //42px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  overflow: hidden;
  width: 250%;

  @media screen and (max-width: 1152px) {
    padding: 22px;
  }
  @media screen and (max-width: 1500px) {
    width: 150%;
  }
  @media screen and (max-width: 1500px) {
    width: 250%;
  }
  @media screen and (max-width: 1200px) {
    width: 340%;
  }
  @media screen and (max-width: 800px) {
    width: 430%;
  }
  @media screen and (max-width: 500px) {
    width: 630%;
  }
`;

interface ButtonWeekProps {
  isChecked: boolean;
}

export const ButtonWeek = styled.button<ButtonWeekProps>`
  background: ${(props) => (props.isChecked ? props.theme.colors.primary : '')};
  border: none;
  border-radius: 50%;
  width: 64px;
  height: 64px;

  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;

  p {
    font-size: 18px;
    margin-bottom: 0px;
    /* line-height: 36px; */
    color: ${(props) =>
      props.isChecked ? props.theme.colors.white : props.theme.colors.gray6};
  }

  @media screen and (max-width: 1152px) {
    width: 56px;
    height: 56px;

    p {
      font-size: 18px;
    }
  }

  transition: background 0.2s;

  &:hover {
    background: ${(props) => props.theme.colors.primary};

    p {
      color: ${(props) => props.theme.colors.white};
    }
  }
`;

export const BodyMonth = styled.section`
  padding: 16px 0 0 0; //26px 37px;

  @media screen and (max-width: 1152px) {
    padding: 16px 0 0 0;
  }

  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  aside {
    div {
      width: 75px; //100px;
      height: 160px; //200px;

      display: flex;
      align-items: flex-start;
      justify-content: flex-start;

      article {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      svg {
        color: ${(props) => props.theme.colors.primary};
        width: 20px; //24px;
        height: 20px; //24px;
        margin-right: 10px; //14px;
      }

      p {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 20px; //24px;
        line-height: 36px;
        color: ${(props) => props.theme.colors.gray6};
      }

      @media screen and (max-width: 1152px) {
        width: 65px;

        svg {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }

        p {
          font-size: 18px;
        }
      }
    }
  }
`;

interface ContainerLineProps {
  contTime: number;
}

export const ContainerLine = styled.div<ContainerLineProps>`
  height: ${(props) => `calc(${props.contTime} * 160px)`};
  background: ${(props) => props.theme.colors.gray6};
  width: 0.8px;
`;

export const ContainerNotion = styled.div`
  width: 100vw;
  max-width: calc(100vw - 390px);

  @media screen and (max-width: 1152px) {
    max-width: calc(100vw - 130px);
  }

  section {
    border-top: 0.1px solid ${(props) => props.theme.colors.gray6};
    padding: 0 18px; //0 38px;
    height: 160px;
    overflow: auto;

    display: flex;

    @media screen and (max-width: 1152px) {
      padding: 0 18px;
    }
  }
`;

interface ButtonCardProps {
  backgroundProps: string;
  typeProps: 'leitura' | 'escrita';
}

export const ButtonCard = styled.button<ButtonCardProps>`
  border: none;
  background: transparent;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${(props) => (props.typeProps === 'escrita' ? 'pointer' : 'default')};

  ul {
    width: max-content;
    padding: 13px 26px; //23px 33px;
    background: ${(props) =>
      props.backgroundProps === props.theme.colors.warning
        ? props.backgroundProps
        : props.theme.colors.primary};
    border-radius: 16px;
    position: relative;
    transition: background 0.2s;

    @media screen and (max-width: 1152px) {
      padding: 13px 26px;
    }

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    li {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px; //18px;
      line-height: 22px; //27px;
      color: ${(props) => props.theme.colors.white};

      @media screen and (max-width: 1152px) {
        font-size: 14px;
        line-height: 20px;
      }
    }

    img {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 12px;
      right: 15px;
    }
  }

  & + button {
    margin-left: 20px;
  }

  &:hover {
    ul {
      background: ${(props) => shade(0.1, props.backgroundProps)};
    }
  }
`;

export const ContainerSemResultados = styled.div`
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  margin-top: 30px;
  padding: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  h2 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: ${(props) => props.theme.colors.black3};
  }
`;
